<script setup>
import { stateManager } from '@/stateManager';
import VerseRow from './VerseRow.vue';
import salmi from "@/assets/json/salmi.json";

const emit = defineEmits(['updateFavoriteStatus'])
const items = salmi.items;
const props = defineProps({
    psalmIndex: { type: String, required: true },
    favoriteVerses: { type: Array, required: true }, // [1, 4, 6] ...
}); 

function updateHelper() {
    emit('updateFavoriteStatus');
}
</script>

<template>
    <div :class="[{ animationShow_v3_fast: stateManager.animationEnabled}, 'salmoContent' ]">
        <VerseRow 
            @updateFavoriteStatus="updateHelper"
            :psalmIndex="psalmIndex" 
            :verseIndex="key" 
            :favoriteVerses="favoriteVerses" 
            v-for="(verseText, key) in items[psalmIndex - 1].content" v-bind:key="key"
        >
            {{ verseText }}
        </VerseRow>
    </div>
</template>